<div class="{{partnerName}}">
    <div class="research-cards">
        <app-research-cards [researchCards]="researchCards" [showEdit]="true" [showRemove]="true" (onCardAction)="onCardAction($event)"></app-research-cards>
        <div class="recommendation-button">
            <div class="recom-button" (click)="openResearchPopup()">
                <ng-container [ngSwitch]="partnerName">
                    <ng-container *ngSwitchCase="PartnerNamesEnum.BETAHEALTH">
                        <img src="/images/private/betahealth/Round Button.svg" alt="Round Button.svg" />
                    </ng-container>
                    <ng-container *ngSwitchCase="PartnerNamesEnum.AVEXTRA">
                        <img src="/images/private/avextra/Round Button.svg" alt="Round Button.svg" />
                    </ng-container>
                    <ng-container *ngSwitchCase="PartnerNamesEnum.ALTHEA">
                        <img src="/images/private/althea/Round Button.svg" alt="Round Button.svg" />
                    </ng-container>
                    <ng-container *ngSwitchCase="PartnerNamesEnum.FOUR_20_PHARMA">
                        <img src="/images/private/420pharma/Round Button.svg" alt="Round Button.svg" />
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <img src="/images/icons/Round Button.svg" alt="Round Button.svg" />
                    </ng-container>
                </ng-container>
                <div class="text">
                    <div>Literatur Recherche App öffnen</div>
                </div>
            </div>
        </div>
        <!--<div class="research-card add-new" (click)="openResearchPopup()">
            <img src="/plus.svg" alt="plus.svg" />
        </div>-->
    </div>
</div>
